import cx from "classnames";
import React from "react";

import { SellerEntity } from "@/mk2/apps/bazaar/schemas";
import { AvatarImg } from "@/mk2/components/AvatarImg";
import { Panel } from "@/mk2/components/Panel";
import { SELLER_STATUS_MESSAGE_FROM_SELLER } from "@/mk/autogenerated/translations/SellerStatusMessage.afdcf54bf87e20c14cb84840a9effe71";
import { urlize } from "@/mk/bazaar/common/filters";

import styles from "./SellerStatusMessage.mscss";

interface OwnProps {
    className?: string;
    seller: SellerEntity;
    hideSeller?: boolean;
    hidePanel?: boolean;
}

type Props = OwnProps;

const SellerStatusMessage = React.memo<Props>(
    ({ className, seller, hideSeller = false, /* onCancel, */ hidePanel }) => {
        const content = (
            <>
                <div className={styles.SellerStatusMessage__content}>
                    {hideSeller ? (
                        <span className={styles.SellerStatusMessage__username}>
                            {SELLER_STATUS_MESSAGE_FROM_SELLER}:
                        </span>
                    ) : (
                        <>
                            <AvatarImg
                                className={styles.SellerStatusMessage__avatar}
                                user={seller.user}
                                size={16}
                            />
                            <span className={styles.SellerStatusMessage__username}>
                                {seller.user.username}:
                            </span>
                        </>
                    )}{" "}
                    <span className={styles.SellerStatusMessage__text}>
                        {urlize(seller.statusMessage, 50)}
                    </span>
                </div>
            </>
        );

        return seller.statusMessage ? (
            hidePanel ? (
                <div className={className}>{content}</div>
            ) : (
                <Panel className={cx(styles.SellerStatusMessage, className)}>{content}</Panel>
            )
        ) : null;
    },
);

SellerStatusMessage.displayName = "SellerStatusMessage";

export default SellerStatusMessage;
